import { apiClient } from '../../../../services/apiClient'
import type {
  Transaction,
  TransactionSearchRequest,
  TransactionSearchResponse,
} from '@popety-io/types'

export const transactionService = {
  /**
   * Get a single transaction by ID
   */
  async getTransaction(id: string, fields?: string[]): Promise<Transaction> {
    const query = fields
      ? `?fields=${encodeURIComponent(fields.join(','))}`
      : ''

    const url = `/transactions/${id}${query}`
    const response = await apiClient.get(url)
    return response.data
  },

  /**
   * Get multiple transactions by IDs (bulk endpoint)
   */
  async getTransactions(
    ids: string[],
    fields?: string[]
  ): Promise<Transaction[]> {
    if (!ids || ids.length === 0) {
      return []
    }

    // Limit to 100 IDs per request as per API constraints
    const limitedIds = ids.slice(0, 100)

    const params = new URLSearchParams()
    params.append('ids', limitedIds.join(','))

    if (fields && fields.length > 0) {
      params.append('fields', fields.join(','))
    }

    const url = `/transactions/bulk?${params.toString()}`
    const response = await apiClient.get(url)
    return response.data
  },

  /**
   * Search for transactions with filters
   */
  async searchTransactions(
    request: TransactionSearchRequest
  ): Promise<TransactionSearchResponse> {
    const response = await apiClient.post('/transactions/search', request)
    return response.data
  },

  /**
   * Get transaction data optimized for history display
   */
  async getTransactionForHistory(id: string): Promise<Transaction> {
    const fields = ['*']

    return this.getTransaction(id, fields)
  },

  /**
   * Get multiple transactions optimized for history display
   */
  async getTransactionsForHistory(ids: string[]): Promise<Transaction[]> {
    const fields = ['*']

    return this.getTransactions(ids, fields)
  },
}
